import queryString from "query-string";

export const ROUTES_MAP = {
    tracker: {
        title: "Tracker - ScraperForce",
        path: "/tracker",
        createURL: (queryParams) => (
            `${ROUTES_MAP.tracker.path}?${queryString.stringify(queryParams)}`
        )
    },
    users: {
        title: "Users - ScraperForce",
        path: "/users",
        createURL: (queryParams) => (
            `${ROUTES_MAP.users.path}?${queryString.stringify(queryParams)}`
        )
    },
    roles: {
        title: "Roles - ScraperForce",
        path: "/roles"
    },
    scheduler: {
        title: "Scheduler - ScraperForce",
        path: "/scheduler",
        createURL: (queryParams) => (
            `${ROUTES_MAP.scheduler.path}?${queryString.stringify(queryParams)}`
        )
    },
    configManager: {
        title: "Config manager - ScraperForce",
        path: "/config-manager",
        createURL: (queryParams) => (
            `${ROUTES_MAP.configManager.path}?${queryString.stringify(queryParams)}`
        )
    },
    configManagerLite: {
        title: "Config manager Lite - ScraperForce",
        path: "/config-manager-lite"
    },
    schedulerStatistic: {
        title: "Scheduler statistic - ScraperForce",
        path: "/scheduler/scheduler-statistic"
    },
    branches: {
        title: "Branches - ScraperForce",
        path: "/branches",
        createURL: (queryParams) => (
            `${ROUTES_MAP.branches.path}?${queryString.stringify(queryParams)}`
        )
    },
    siteGroups: {
        title: "Site Groups - ScraperForce",
        path: "/site-groups",
        createURL: (queryParams) => (
            `${ROUTES_MAP.siteGroups.path}?${queryString.stringify(queryParams)}`
        )
    },
    brands: {
        title: "Brands - ScraperForce",
        path: "/brands",
        createURL: (queryParams) => (
            `${ROUTES_MAP.brands.path}?${queryString.stringify(queryParams)}`
        )
    },
    brandTrackedDomains: {
        title: "Brand Tracked Domains - ScraperForce",
        path: "/brand-tracked-domains",
        createURL: (queryParams) => (
            `${ROUTES_MAP.brandTrackedDomains.path}?${queryString.stringify(queryParams)}`
        )
    },
    userAgents: {
        title: "User agents - ScraperForce",
        path: "/user-agents",
        createURL: (queryParams) => (
            `${ROUTES_MAP.userAgents.path}?${queryString.stringify(queryParams)}`
        )
    },
    initialScrapeTaskBatchStarts: {
        title: "Initial Scrape Task Batch Starts - ScraperForce",
        path: "/initial-scrape-task-batch-starts",
        createURL: (queryParams) => (
            `${ROUTES_MAP.initialScrapeTaskBatchStarts.path}?${queryString.stringify(queryParams)}`
        )
    },
    objectStructures: {
        title: "Object Structures - ScraperForce",
        path: "/object-structures",
        createURL: (queryParams) => (
            `${ROUTES_MAP.objectStructures.path}?${queryString.stringify(queryParams)}`
        )
    },
    configCIPublishRequests: {
        title: "Config CI - Publish Requests",
        path: "/config-ci/publish-requests",
        createURL: (queryParams) => (
            `${ROUTES_MAP.configCIPublishRequests.path}?${queryString.stringify(queryParams)}`
        )
    },
    configCITestTasks: {
        title: "Config CI - Test Tasks",
        path: "/config-ci/test-tasks",
        createURL: (queryParams) => (
            `${ROUTES_MAP.configCITestTasks.path}?${queryString.stringify(queryParams)}`
        )
    },
    metric: {
        title: "Metric - ScraperForce",
        path: "/metric",
        createCollectionStatusURL: (queryParams) => (
            `${ROUTES_MAP.metric.path}/collection-status?${queryString.stringify(queryParams)}`
        ),
        createKeywordScanStatsURL: () => (
            `${ROUTES_MAP.metric.path}/keyword-scan-stats`
        )
    },
    credentials: {
        title: "Credentials Manager - Credentials",
        path: "/credentials",
        createURL: (queryParams) => (
            `${ROUTES_MAP.credentials.path}?${queryString.stringify(queryParams)}`
        )
    },
    credentialsTypes: {
        title: "Credentials Manager - Credentials Types",
        path: "/credentials-types",
        createURL: (queryParams) => (
            `${ROUTES_MAP.credentialsTypes.path}?${queryString.stringify(queryParams)}`
        )
    },
    proxyManager: {
        title: "Proxy Manager - ScraperForce",
        path: "/proxy-manager",
        createURL: (queryParams) => (
            `${ROUTES_MAP.proxyManager.path}?${queryString.stringify(queryParams)}`
        )
    },
    quotaManager: {
        title: "Quota Manager - ScraperForce",
        path: "/quota-manager",
        createURL: (queryParams) => (
            `${ROUTES_MAP.quotaManager.path}?${queryString.stringify(queryParams)}`
        )
    },
    primaryKey: {
        title: "Primary Key Configs - ScraperForce",
        path: "/primary-key/configs",
        createURL: (queryParams) => (
            `${ROUTES_MAP.primaryKey.path}?${queryString.stringify(queryParams)}`
        )
    },
    sqsQueues: {
        title: "SQS Queues - ScraperForce",
        path: "/sqs-queues",
        createURL: (queryParams) => (
            `${ROUTES_MAP.sqsQueues.path}?${queryString.stringify(queryParams)}`
        )
    },
    noPermissions: {
        title: "No permissions",
        path: "/no-permissions"
    }
};

export const DEFAULT_ROUTE = "/";
